import { get, execute, post } from "./AxiosInstance";

async function login(username, password) {
  try {
    let body = {};
    body.username = username;
    body.password = password;
    body.type = "san";
    const response = await post("api/dang-nhap", {}, body);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}

async function getOrderList(page, per_page) {
  try {
    let params = {};
    params.page = page;
    params.per_page = per_page;
    const response = await get("api/web-sell/order/list", params);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}

async function getSellList(page, per_page) {
  try {
    let params = {};
    params.page = page;
    params.per_page = per_page;
    const response = await get("api/web-sell/order/listSellStore", params);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}
async function getDrugCategory(page, per_page, category_id, txtSearch) {
  try {
    let params = {};
    params.page = page;
    params.per_page = per_page;
    params.category_id = category_id;
    params.txtSearch = txtSearch;
    const response = await get("api/web-sell/category/listdrug", params);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}
async function getInfoCategory(category_id) {
  try {
    let params = {};
    params.category_id = category_id;
    const response = await get("api/web-sell/category/information", params);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}
async function getProductSelling(fromPage, drug_store_id) {
  try {
    let params = {};
    const response = await get("api/web-sell/drug/topSell", params);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}
async function getProductDetails(drug_id) {
  try {
    let params = {};
    params.drug_id = drug_id;
    const response = await get("api/web-sell/drugstore/detail", params);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}
async function getAgentsSameProduct(
  page,
  per_page,
  drug_id,
  filter_address,
  filter_price
) {
  try {
    let params = {};
    params.page = page;
    params.per_page = per_page;
    params.drug_id = drug_id;
    params.filter_address = filter_address;
    params.filter_price = filter_price;
    const response = await get("api/web-sell/drug/drug-sell", params);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}
async function getProvince() {
  try {
    let params = {};
    const response = await get("/api/web-sell/address/listProvince", params);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}
async function getDistrict(province_code) {
  try {
    let params = {};
    const response = await get(
      "/api/web-sell/address/listDistrict/" + province_code,
      params
    );
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}
async function getWards(district_code) {
  try {
    let params = {};
    const response = await get(
      "/api/web-sell/address/listWard/" + district_code,
      params
    );
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}
async function getAgentsList(search, page,per_page) {
  try {
    let params = {};
    params.page = page;
    params.per_page = per_page;
    params.search = search;
    const response = await get("api/web-sell/search/drug-store", params);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}

async function getListCategory() {
  try {
    let params = {};
    const response = await get("api/web-sell/category/list", params);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}

async function getListBanner(from = "home") {
  try {
    let params = {};
    params.from = from;
    const response = await get("api/web-sell/banner/list", params);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}
async function suggestCate() {
  try {
    let params = {};
    const response = await get(
      "api/web-sell/drug/suggest/featuredCate",
      params
    );
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}

async function suggestProduct(cateId) {
  try {
    let params = {};
    params.cateId = cateId;
    params.page = 1;
    params.per_page = 15;
    const response = await get("api/web-sell/drug/suggest", params);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}

async function getCart() {
  try {
    let params = {};
    const response = await get(
      "api/web-sell/drugstore/shoppingcart/get",
      params
    );
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}
async function getTopSuggets(limit, drug_id, unit_id) {
  try {
    let params = {};
    params.limit = limit;
    params.drug_id = drug_id;
    params.unit_id = unit_id;
    const response = await get("api/web-sell/drug/top-suggest", params);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}
async function getAgencyDetails(drug_store_id) {
  try {
    let params = {};
    params.drug_store_id = drug_store_id;
    const response = await get(
      "api/web-sell/drugstore/information/" + drug_store_id
    );
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}
async function getAgencyCategory(drug_store_id) {
  try {
    let params = {};
    params.drug_store_id = drug_store_id;
    const response = await get("api/web-sell/drug/drugCategory", params);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}

async function updateNumberCart(quantity, unit_id, drug_id) {
  try {
    let body = {};
    body.quantity = quantity;
    body.unit_id = unit_id;
    body.drug_id = drug_id;
    const response = await post(
      "api/web-sell/drugstore/shoppingcart/update",
      {},
      body
    );
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}

async function deleleItemCart(unit_id, drug_id) {
  try {
    let body = {};
    body.unit_id = unit_id;
    body.drug_id = drug_id;
    const response = await post(
      "api/web-sell/drugstore/shoppingcart/detroy",
      {},
      body
    );
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}

async function addItemCart(drug_id, quantity, unit_id) {
  try {
    let body = {};
    body.drug_id = drug_id;
    body.quantity = quantity;
    body.unit_id = unit_id;
    const response = await post(
      "api/web-sell/drugstore/shoppingcart/add",
      {},
      body
    );
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}

async function getPayment(drug_store_id) {
  try {
    let params = {};
    params.vouchers = [];
    params.drug_store_id = drug_store_id;
    const response = await get(
      "api/web-sell/drugstore/shoppingcart/payment",
      params
    );
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}

async function getSearchSuggest() {
  try {
    let params = {};
    params.page = 1;
    params.per_page = 8;
    const response = await get("api/web-sell/search/suggest", params);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}

async function getSearchProduct(search) {
  try {
    let params = {};
    params.search = search;
    params.page = 1;
    params.per_page = 8;
    const response = await get("api/web-sell/search/drug-master", params);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}

async function confirmOrder(drug_store_id, paymen_method, drug_address_info) {
  try {
    let body = {};
    body.drug_store_id = drug_store_id;
    body.paymen_method = paymen_method;
    body.drug_address_info = drug_address_info;
    const response = await post(
      "api/web-sell/drugstore/shoppingcart/confirm-order",
      {},
      body
    );
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}
async function contact(topic, title, content, fullname, email, phone) {
  try {
    let body = {};
    body.topic = topic;
    body.title = title;
    body.content = content;
    body.fullname = fullname;
    body.email = email;
    body.phone = phone;
    const response = await post("api/web-sell/contact/add", {}, body);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}
async function register(familyname, fullname, phone, email, password) {
  try {
    let body = {};
    body.familyname = familyname;
    body.fullname = fullname;
    body.phone = phone;
    body.email = email;
    body.password = password;
    const response = await post("api/web-sell/contact/add-register", {}, body);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}
async function getDeliveryDefault() {
  try {
    const response = await get("api/web-sell/address/delivery/getDefault");
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}

async function getDrugList(search, drug_store_id, cate_id, page, per_page) {
  try {
    let params = {};
    params.search = search;
    params.drug_store_id = drug_store_id;
    params.cate_id = cate_id;
    params.page = page;
    params.per_page = per_page;
    const response = await get("api/web-sell/drug", params);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}

async function drugSearchSuggestion(search) {
  try {
    let params = {};
    params.search = search;
    params.match_all = false;
    const response = await get("api/web-sell/drug/search/suggestion", params);
    const data = await execute(response, false);
    return data;
  } catch (error) {
    console.error(error);
  }
}


const APIService = {
  getOrderList,
  getSellList,
  getProductSelling,
  getProvince,
  getDistrict,
  getWards,
  getInfoCategory,
  login,
  getDrugCategory,
  getListCategory,
  getListBanner,
  suggestCate,
  suggestProduct,
  getProductDetails,
  getAgentsSameProduct,
  getAgentsList,
  getCart,
  getTopSuggets,
  getAgencyDetails,
  updateNumberCart,
  deleleItemCart,
  addItemCart,
  getPayment,
  getAgencyCategory,
  getSearchSuggest,
  getSearchProduct,
  confirmOrder,
  contact,
  register,
  getDeliveryDefault,
  getDrugList,
  drugSearchSuggestion
};

export default APIService;
